import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { ErrorOutline as DefaultIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const NotFound = ({
  message = "404: Page Not Found", // Main message
  secondaryMessage = "Oops! The page you are looking for does not exist or has been moved.", // Secondary message
  redirectPath = "/", // Redirect URL
  buttonText = "Go to Home", // Button text
  icon = <DefaultIcon sx={{ fontSize: "80px", color: "red", marginBottom: "20px" }} />, // Custom icon
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: "30px",
          maxWidth: "600px",
          textAlign: "center",
          borderRadius: "12px",
        }}
      >
        {/* Dynamic Icon */}
        {icon}

        <Typography
          variant="h4"
          sx={{
            marginBottom: "20px",
            fontWeight: "bold",
          }}
        >
          {message}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            marginBottom: "30px",
            fontSize: "16px",
            color: "#555",
          }}
        >
          {secondaryMessage}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{
            fontSize: "16px",
            padding: "10px 20px",
            textTransform: "none",
            borderRadius: "8px",
          }}
          onClick={() => navigate(redirectPath)}
        >
          {buttonText}
        </Button>
      </Paper>
    </Box>
  );
};

export default NotFound;
